<template>
    <span v-if="physician" class="name w3-margin">
        {{ physician.name }}
        <span v-if="physician.agendaSystemIds && physician.agendaSystemIds.length > 0">
            ({{ physician.agendaSystemIds.join(",") }})
        </span>
        - <b>{{ physician.ward.displayName }}</b>
    </span>
</template>

<script>
    export default {
        name: "PhysicianEntry",
        props: ["physician"]
    }
</script>

<style scoped>

</style>